export default class CommonConstants {
     public static STATE = {
        'CREATE_IN_PROGRESS' : 'CREATE_IN_PROGRESS',
        'IN_PROGRESS': 'IN_PROGRESS',
        'DELETE_IN_PROGRESS': 'DELETE_IN_PROGRESS',
        'REALIZED': 'REALIZED',
        'NOT_REALIZED': 'NOT_REALIZED',
        'ERROR': 'ERROR'
    }
    public static EDGETYPE = {
        'DISTRIBUTED_ROUTER': 'distributedRouter',
        'GATEWAY_SERVICES': 'gatewayServices',
        'SDDC_GATEWAY': 'sddcGateway'
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/common/common-constants.ts